import {useRef } from 'react';
import { Link } from 'react-router-dom';

const Header = () => { 

  const menu = useRef(null);
  // const menuSm = useRef(null);
  const mobile = useRef(null);

  function showMobile() {
    mobile.current.classList.toggle('active');
    menu.current.classList.toggle('active');
  }

  function botClick(name, proceed, instructions) {
    let choice = window.confirm(`Натисніть "ОК", якщо ви вже ознайомлені з принципом роботи бота ${name}.`);

    if (choice) {
        window.location = proceed;
    } else {
        window.location = instructions;
    }
  }

  function botClickTelegram() {
    console.log('tel click')
    botClick('Telegram', 'https://t.me/ZhtoeBot', 'https://ztoe.com.ua/img/telegr.pdf');
  }

  function botClickViber() {
    botClick('Viber', 'viber://pa?chatURI=zhitomirenergo', 'https://ztoe.com.ua/img/viber.pdf');
  }

    return (
        <header className="header">
        <div className="menu-blue">
          <button className="menu-mobile" onClick={showMobile} ref={mobile}>
            <span></span>
          </button>
          <img className='logo-mobile' fetchpriority="high" src="/img/logo.png" alt= "icon"/>
        </div>
          <div className="header__inner">
              <div id="customer-info" class="container-common mobile-hide">
                <div id="customer-info-view" class="view-common">
                    <a href="https://www.ztoe.com.ua" id="customer-info-logo">
                        <img fetchpriority="high" src="/img/logo.png" alt= "icon"/>
                    </a>
                    <div class="customer-info-separator"></div>
                    <div id="customer-info-support">
                        <div>
                            <p>Кол-центр:</p>
                        </div>
                        <div id="customer-info-support-links">
                            <a href="tel:+380412559282">
                                <img fetchpriority="high" src="/img/icons/phone.png" alt= "icon"/>
                                <p><b>(0412)</b> 55-92-82</p>
                            </a>
                            <a href="tel:+380800309282">
                                <img fetchpriority="high" src="/img/icons/phone.png" alt= "icon"/>
                                <p><b>(0800)</b> 30-92-82</p>
                            </a>
                            <a href="tel:+380671559282">
                                <img fetchpriority="high" src="/img/icons/phone.png" alt= "icon"/>
                                <p><b>(067)</b> 155-92-82</p>
                            </a>
                            <a href="tel:+380956559282">
                                <img fetchpriority="high" src="/img/icons/phone.png" alt= "icon"/>
                                <p><b>(095)</b> 655-92-82</p>
                            </a>
                            <a href="mailto:call1@co.ztoe.com.ua" class="link-inherit decoration-underline">
                                <img fetchpriority="high" src="/img/icons/mail.png" alt= "icon"/>
                                <p>call1@co.ztoe.com.ua</p>
                            </a>
                        </div>
                    </div>
                    <div class="customer-info-separator"></div>
                    <div id="customer-info-submit">
                        <div>
                            <a href="https://www.ztoe.com.ua" class="button-big">Повернутись на сайт Житомиробленерго</a>
                        </div>
                    </div>
                    <div class="customer-info-separator"></div>
                    <div id="customer-info-methods">
                        <div>
                            <p>Передача показників</p>
                            <p>через бот-канали:</p>
                        </div>
                        <div>
                            <div onClick={()=>botClickViber()}>
                                <img fetchpriority="high" src="/img/icons/viber.png" alt= "icon"/>
                            </div>
                            <div onClick={()=>botClickTelegram()}>
                                <img fetchpriority="high" src="/img/icons/telegram.png" alt= "icon"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
          <div className="menu-blue bottom">
            <nav className="menu big" ref={menu}>
              <ul className="menu__list">
                <li className="menu__list-item">
                  <Link aria-current="page" className="drop" to="/" onClick={showMobile}> Чому немає світла? </Link>
                </li>
                <div class="nav-bar-separator">
                  <img fetchpriority="high" src="/img/icons/vertical.png" alt= "icon"/>
                </div>
                <li className="menu__list-item">
                  <Link aria-current="page" className="drop" to="/planovi_vidkluchenna" onClick={showMobile}> Планові відключеня </Link>
                </li>
              </ul>
              </nav>
          </div>
        </header>
    );
};

export default Header;